/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
/** Supported OAuth / federated identity provider */
export var OAuthProvider;
(function (OAuthProvider) {
    OAuthProvider["Google"] = "google";
    OAuthProvider["Apple"] = "apple";
    OAuthProvider["Facebook"] = "facebook";
    OAuthProvider["Github"] = "github";
    OAuthProvider["Slack"] = "slack";
    OAuthProvider["Atproto"] = "atproto";
})(OAuthProvider || (OAuthProvider = {}));
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["JsonApi"] = "application/vnd.api+json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    constructor(apiConfig = {}) {
        this.baseUrl = "https://api.auth.gaz.codes";
        this.securityData = null;
        this.abortControllers = new Map();
        this.customFetch = (...fetchParams) => fetch(...fetchParams);
        this.baseApiParams = {
            credentials: "same-origin",
            headers: {},
            redirect: "follow",
            referrerPolicy: "no-referrer",
        };
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.contentFormatters = {
            [ContentType.Json]: (input) => input !== null && (typeof input === "object" || typeof input === "string")
                ? JSON.stringify(input)
                : input,
            [ContentType.JsonApi]: (input) => input !== null && (typeof input === "object" || typeof input === "string")
                ? JSON.stringify(input)
                : input,
            [ContentType.Text]: (input) => input !== null && typeof input !== "string"
                ? JSON.stringify(input)
                : input,
            [ContentType.FormData]: (input) => {
                if (input instanceof FormData) {
                    return input;
                }
                return Object.keys(input || {}).reduce((formData, key) => {
                    const property = input[key];
                    formData.append(key, property instanceof Blob
                        ? property
                        : typeof property === "object" && property !== null
                            ? JSON.stringify(property)
                            : `${property}`);
                    return formData;
                }, new FormData());
            },
            [ContentType.UrlEncoded]: (input) => this.toQueryString(input),
        };
        this.createAbortSignal = (cancelToken) => {
            if (this.abortControllers.has(cancelToken)) {
                const abortController = this.abortControllers.get(cancelToken);
                if (abortController) {
                    return abortController.signal;
                }
                return void 0;
            }
            const abortController = new AbortController();
            this.abortControllers.set(cancelToken, abortController);
            return abortController.signal;
        };
        this.abortRequest = (cancelToken) => {
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                abortController.abort();
                this.abortControllers.delete(cancelToken);
            }
        };
        this.request = async ({ body, secure, path, type, query, format, baseUrl, cancelToken, ...params }) => {
            const secureParams = ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const queryString = query && this.toQueryString(query);
            const payloadFormatter = this.contentFormatters[type || ContentType.Json];
            const responseFormat = format || requestParams.format;
            return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
                ...requestParams,
                headers: {
                    ...(requestParams.headers || {}),
                    ...(type && type !== ContentType.FormData
                        ? { "Content-Type": type }
                        : {}),
                },
                signal: (cancelToken
                    ? this.createAbortSignal(cancelToken)
                    : requestParams.signal) || null,
                body: typeof body === "undefined" || body === null
                    ? null
                    : payloadFormatter(body),
            }).then(async (response) => {
                const r = response;
                r.data = null;
                r.error = null;
                const responseToParse = responseFormat ? response.clone() : response;
                const data = !responseFormat
                    ? r
                    : await responseToParse[responseFormat]()
                        .then((data) => {
                        if (r.ok) {
                            r.data = data;
                        }
                        else {
                            r.error = data;
                        }
                        return r;
                    })
                        .catch((e) => {
                        r.error = e;
                        return r;
                    });
                if (cancelToken) {
                    this.abortControllers.delete(cancelToken);
                }
                if (!response.ok)
                    throw data;
                return data;
            });
        };
        Object.assign(this, apiConfig);
    }
    encodeQueryParam(key, value) {
        const encodedKey = encodeURIComponent(key);
        return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
    }
    addQueryParam(query, key) {
        return this.encodeQueryParam(key, query[key]);
    }
    addArrayQueryParam(query, key) {
        const value = query[key];
        return value.map((v) => this.encodeQueryParam(key, v)).join("&");
    }
    toQueryString(rawQuery) {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
        return keys
            .map((key) => Array.isArray(query[key])
            ? this.addArrayQueryParam(query, key)
            : this.addQueryParam(query, key))
            .join("&");
    }
    addQueryParams(rawQuery) {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? `?${queryString}` : "";
    }
    mergeRequestParams(params1, params2) {
        return {
            ...this.baseApiParams,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.baseApiParams.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
}
/**
 * @title Authentication Service API
 * @version 1.0.0
 * @baseUrl https://api.auth.gaz.codes
 *
 * A comprehensive authentication service supporting multiple authentication methods:
 * - Email/password with optional MFA
 * - Magic link authentication
 * - Phone number with TOTP/SMS
 * - OAuth providers (Google, Apple, Facebook, Twitter, GitHub)
 * - WebAuthn/Passkeys
 * - AT Protocol (Bluesky) OAuth login and account linking
 * - TOTP-based MFA
 *
 * Additional capabilities:
 * - Identity verification via Holonym ZK proofs and Reclaim Protocol
 * - Selective disclosure identity wallet with AT Protocol publishing
 * - Tier-based access control with plan management
 * - Admin dashboard for user, plan, and lifecycle management
 *
 * Designed with security-first principles including rate limiting, session management,
 * device tracking, and comprehensive audit logging.
 */
export class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * @description Retrieve the OpenAPI specification for this API in JSON format
             *
             * @tags Specification
             * @name GetOpenApiSpecJson
             * @summary Get OpenAPI specification (JSON)
             * @request GET:/v1/openapi.json
             * @secure
             */
            getOpenApiSpecJson: (params = {}) => this.request({
                path: `/v1/openapi.json`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Retrieve the OpenAPI specification for this API in YAML format
             *
             * @tags Specification
             * @name GetOpenApiSpecYaml
             * @summary Get OpenAPI specification (YAML)
             * @request GET:/v1/openapi.yaml
             * @secure
             */
            getOpenApiSpecYaml: (params = {}) => this.request({
                path: `/v1/openapi.yaml`,
                method: "GET",
                secure: true,
                ...params,
            }),
            /**
             * @description Register a new user account using email and password
             *
             * @tags Registration
             * @name RegisterWithEmail
             * @summary Register with email and password
             * @request POST:/v1/register/email
             * @secure
             */
            registerWithEmail: (data, params = {}) => this.request({
                path: `/v1/register/email`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Register a new user account using phone number (requires SMS/TOTP verification)
             *
             * @tags Registration
             * @name RegisterWithPhone
             * @summary Register with phone number
             * @request POST:/v1/register/phone
             * @secure
             */
            registerWithPhone: (data, params = {}) => this.request({
                path: `/v1/register/phone`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Authenticate using email and password credentials
             *
             * @tags Authentication
             * @name LoginWithEmail
             * @summary Login with email and password
             * @request POST:/v1/login
             * @secure
             */
            loginWithEmail: (data, params = {}) => this.request({
                path: `/v1/login`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Send a magic link to the user's email for passwordless authentication
             *
             * @tags Authentication
             * @name RequestMagicLink
             * @summary Request magic link
             * @request POST:/v1/magic-link
             * @secure
             */
            requestMagicLink: (data, params = {}) => this.request({
                path: `/v1/magic-link`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Complete magic link authentication using the token from email
             *
             * @tags Authentication
             * @name VerifyMagicLink
             * @summary Verify magic link token
             * @request POST:/v1/magic-link/verify
             * @secure
             */
            verifyMagicLink: (data, params = {}) => this.request({
                path: `/v1/magic-link/verify`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Initiate phone number authentication (sends SMS/TOTP code)
             *
             * @tags Authentication
             * @name LoginWithPhone
             * @summary Login with phone number
             * @request POST:/v1/login/phone
             * @secure
             */
            loginWithPhone: (data, params = {}) => this.request({
                path: `/v1/login/phone`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Complete phone authentication using verification code
             *
             * @tags Authentication
             * @name VerifyPhoneLogin
             * @summary Verify phone login code
             * @request POST:/v1/login/phone/verify
             * @secure
             */
            verifyPhoneLogin: (data, params = {}) => this.request({
                path: `/v1/login/phone/verify`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description The single redirect URI registered with every provider. Exchanges the code, signs in (or links, or vaults) and redirects to the flow destination with session cookies set, or to the auth FE error page.
             *
             * @tags OAuth
             * @name OauthCallback
             * @summary OAuth provider redirect target
             * @request GET:/v1/oauth/callback
             * @secure
             */
            oauthCallback: (query, params = {}) => this.request({
                path: `/v1/oauth/callback`,
                method: "GET",
                query: query,
                secure: true,
                ...params,
            }),
            /**
             * @description Start WebAuthn/passkey registration process
             *
             * @tags WebAuthn
             * @name BeginWebAuthnRegistration
             * @summary Begin WebAuthn registration
             * @request POST:/v1/webauthn/register/initiate
             * @secure
             */
            beginWebAuthnRegistration: (data, params = {}) => this.request({
                path: `/v1/webauthn/register/initiate`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Complete WebAuthn/passkey registration with client response
             *
             * @tags WebAuthn
             * @name CompleteWebAuthnRegistration
             * @summary Complete WebAuthn registration
             * @request POST:/v1/webauthn/register/complete
             * @secure
             */
            completeWebAuthnRegistration: (data, params = {}) => this.request({
                path: `/v1/webauthn/register/complete`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Start WebAuthn/passkey authentication process
             *
             * @tags WebAuthn
             * @name BeginWebAuthnLogin
             * @summary Begin WebAuthn authentication
             * @request POST:/v1/webauthn/authenticate/initiate
             * @secure
             */
            beginWebAuthnLogin: (data, params = {}) => this.request({
                path: `/v1/webauthn/authenticate/initiate`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Complete WebAuthn/passkey authentication with client response
             *
             * @tags WebAuthn
             * @name CompleteWebAuthnLogin
             * @summary Complete WebAuthn authentication
             * @request POST:/v1/webauthn/authenticate/complete
             * @secure
             */
            completeWebAuthnLogin: (data, params = {}) => this.request({
                path: `/v1/webauthn/authenticate/complete`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Get list of registered WebAuthn/passkey credentials for authenticated user
             *
             * @tags WebAuthn
             * @name ListWebAuthnCredentials
             * @summary List WebAuthn credentials
             * @request GET:/v1/webauthn/credentials
             * @secure
             */
            listWebAuthnCredentials: (params = {}) => this.request({
                path: `/v1/webauthn/credentials`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Remove a specific WebAuthn/passkey credential
             *
             * @tags WebAuthn
             * @name DeleteWebAuthnCredential
             * @summary Delete WebAuthn credential
             * @request DELETE:/v1/webauthn/credentials/{credentialId}
             * @secure
             */
            deleteWebAuthnCredential: (credentialId, params = {}) => this.request({
                path: `/v1/webauthn/credentials/${credentialId}`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Generate TOTP secret and QR code for MFA setup
             *
             * @tags MFA
             * @name SetupTotp
             * @summary Setup TOTP MFA
             * @request POST:/v1/mfa/setup
             * @secure
             */
            setupTotp: (params = {}) => this.request({
                path: `/v1/mfa/setup`,
                method: "POST",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Verify TOTP code and enable MFA for account
             *
             * @tags MFA
             * @name VerifyAndEnableTotp
             * @summary Verify and enable TOTP
             * @request POST:/v1/mfa/verify
             * @secure
             */
            verifyAndEnableTotp: (data, params = {}) => this.request({
                path: `/v1/mfa/verify`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Provide MFA code to complete authentication
             *
             * @tags MFA
             * @name CompleteMfaChallenge
             * @summary Complete MFA challenge
             * @request POST:/v1/mfa/challenge
             * @secure
             */
            completeMfaChallenge: (data, params = {}) => this.request({
                path: `/v1/mfa/challenge`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Exchange refresh token for new access token
             *
             * @tags Token Management
             * @name RefreshToken
             * @summary Refresh access token
             * @request POST:/v1/refresh
             * @secure
             */
            refreshToken: (data, params = {}) => this.request({
                path: `/v1/refresh`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Invalidate current session and tokens
             *
             * @tags Session Management
             * @name Logout
             * @summary Logout user
             * @request POST:/v1/logout
             * @secure
             */
            logout: (data, params = {}) => this.request({
                path: `/v1/logout`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Invalidate all sessions and refresh tokens for the user
             *
             * @tags Session Management
             * @name LogoutAll
             * @summary Logout from all devices
             * @request POST:/v1/logout/all
             * @secure
             */
            logoutAll: (params = {}) => this.request({
                path: `/v1/logout/all`,
                method: "POST",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Verify user's email address using verification token
             *
             * @tags Account Management
             * @name VerifyEmail
             * @summary Verify email address
             * @request POST:/v1/verify-email
             * @secure
             */
            verifyEmail: (data, params = {}) => this.request({
                path: `/v1/verify-email`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Send a new email verification link or SMS verification code
             *
             * @tags Account Management
             * @name ResendVerification
             * @summary Resend verification email or SMS
             * @request POST:/v1/resend-verification
             * @secure
             */
            resendVerification: (data, params = {}) => this.request({
                path: `/v1/resend-verification`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Send password reset link to user's email
             *
             * @tags Password Management
             * @name ForgotPassword
             * @summary Request password reset
             * @request POST:/v1/password/reset
             * @secure
             */
            forgotPassword: (data, params = {}) => this.request({
                path: `/v1/password/reset`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Reset password using reset token from email
             *
             * @tags Password Management
             * @name ResetPassword
             * @summary Reset password
             * @request POST:/v1/password/reset/confirm
             * @secure
             */
            resetPassword: (data, params = {}) => this.request({
                path: `/v1/password/reset/confirm`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Change password for authenticated user
             *
             * @tags Password Management
             * @name ChangePassword
             * @summary Change password
             * @request POST:/v1/password/change
             * @secure
             */
            changePassword: (data, params = {}) => this.request({
                path: `/v1/password/change`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Retrieve authenticated user's profile information
             *
             * @tags User Profile
             * @name GetCurrentUser
             * @summary Get current user profile
             * @request GET:/v1/profile
             * @secure
             */
            getCurrentUser: (params = {}) => this.request({
                path: `/v1/profile`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Update profile fields for the authenticated user. Returns updated profile and refreshes user_info cookie.
             *
             * @tags User Profile
             * @name UpdateProfile
             * @summary Update current user profile
             * @request PATCH:/v1/profile
             * @secure
             */
            updateProfile: (data, params = {}) => this.request({
                path: `/v1/profile`,
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description A five-minute token of type `collab` for opening a collab (Hocuspocus) WebSocket, minted from the session cookie. Collab servers accept it; every HTTP API refuses it, so the session token itself is never handed to page script.
             *
             * @tags Authentication
             * @name GetCollabToken
             * @summary Get a collab socket token
             * @request GET:/v1/collab-token
             * @secure
             */
            getCollabToken: (params = {}) => this.request({
                path: `/v1/collab-token`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get presigned S3 URLs for direct avatar upload (multiple sizes). This method avoids base64 encoding overhead and is the recommended approach for uploading avatars. After uploading to the presigned URLs, call /v1/avatar/confirm to update the user record. Supports both legacy single-file format and new multi-file format.
             *
             * @tags User Profile
             * @name GetAvatarUploadUrl
             * @summary Get presigned URL for avatar upload
             * @request POST:/v1/avatar/upload-url
             * @secure
             */
            getAvatarUploadUrl: (data, params = {}) => this.request({
                path: `/v1/avatar/upload-url`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Confirm that an avatar was successfully uploaded to S3 and update the user record. This endpoint verifies the file exists and updates the user's avatarUrl field.
             *
             * @tags User Profile
             * @name ConfirmAvatarUpload
             * @summary Confirm avatar upload
             * @request POST:/v1/avatar/confirm
             * @secure
             */
            confirmAvatarUpload: (data, params = {}) => this.request({
                path: `/v1/avatar/confirm`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Generate presigned URLs for uploading multiple sizes of a background image to S3. After uploading all files to S3 using the presigned URLs, call /v1/background/confirm to update the user record.
             *
             * @tags User Profile
             * @name GetBackgroundUploadUrl
             * @summary Get presigned URL for background image upload
             * @request POST:/v1/background/upload-url
             * @secure
             */
            getBackgroundUploadUrl: (data, params = {}) => this.request({
                path: `/v1/background/upload-url`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Confirm that background images were successfully uploaded to S3 and update the user record. This endpoint verifies at least one file exists and updates the user's backgroundUrl field.
             *
             * @tags User Profile
             * @name ConfirmBackgroundUpload
             * @summary Confirm background image upload
             * @request POST:/v1/background/confirm
             * @secure
             */
            confirmBackgroundUpload: (data, params = {}) => this.request({
                path: `/v1/background/confirm`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Retrieve a user's public profile by username. Access is controlled by the user's visibility setting: private (owner only), registered (authenticated users), or everyone.
             *
             * @tags User Profile
             * @name GetPublicProfile
             * @summary Get public profile by username
             * @request GET:/v1/profile/{username}
             * @secure
             */
            getPublicProfile: (username, params = {}) => this.request({
                path: `/v1/profile/${username}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Update the visibility setting for the current user's profile
             *
             * @tags User Profile
             * @name UpdateProfileVisibility
             * @summary Update profile visibility
             * @request PUT:/v1/user/profile-visibility
             * @secure
             */
            updateProfileVisibility: (data, params = {}) => this.request({
                path: `/v1/user/profile-visibility`,
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Get list of active sessions for the current user
             *
             * @tags Session Management
             * @name ListSessions
             * @summary List active sessions
             * @request GET:/v1/sessions
             * @secure
             */
            listSessions: (params = {}) => this.request({
                path: `/v1/sessions`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Revoke a specific session by ID
             *
             * @tags Session Management
             * @name RevokeSession
             * @summary Revoke specific session
             * @request DELETE:/v1/sessions/{sessionId}
             * @secure
             */
            revokeSession: (sessionId, params = {}) => this.request({
                path: `/v1/sessions/${sessionId}`,
                method: "DELETE",
                secure: true,
                ...params,
            }),
            /**
             * @description Generate a presigned S3 URL for direct file upload. After uploading to the presigned URL, call /v1/files/confirm to create the file record.
             *
             * @tags File Management
             * @name GetFileUploadUrl
             * @summary Get presigned upload URL
             * @request POST:/v1/files/upload-url
             * @secure
             */
            getFileUploadUrl: (data, params = {}) => this.request({
                path: `/v1/files/upload-url`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Confirm a file upload after successfully uploading to the presigned S3 URL. Creates the file record and updates storage usage.
             *
             * @tags File Management
             * @name ConfirmFileUpload
             * @summary Confirm file upload
             * @request POST:/v1/files/confirm
             * @secure
             */
            confirmFileUpload: (data, params = {}) => this.request({
                path: `/v1/files/confirm`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Get storage usage and quota information for the current user.
             *
             * @tags File Management
             * @name GetFileUsage
             * @summary Get storage usage
             * @request GET:/v1/files/usage
             * @secure
             */
            getFileUsage: (params = {}) => this.request({
                path: `/v1/files/usage`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description List files for the current user with pagination and filtering.
             *
             * @tags File Management
             * @name ListFiles
             * @summary List files
             * @request GET:/v1/files
             * @secure
             */
            listFiles: (query, params = {}) => this.request({
                path: `/v1/files`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get details for a specific file by ID.
             *
             * @tags File Management
             * @name GetFile
             * @summary Get file details
             * @request GET:/v1/files/{fileId}
             * @secure
             */
            getFile: (fileId, params = {}) => this.request({
                path: `/v1/files/${fileId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Delete a file by ID. Removes from S3 and updates storage usage.
             *
             * @tags File Management
             * @name DeleteFile
             * @summary Delete file
             * @request DELETE:/v1/files/{fileId}
             * @secure
             */
            deleteFile: (fileId, params = {}) => this.request({
                path: `/v1/files/${fileId}`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Submit a Holonym ZK proof for identity verification. The proof is cryptographically verified server-side using the Holonym off-chain SDK.
             *
             * @tags Identity Verification
             * @name SubmitIdentityVerification
             * @summary Submit identity verification proof
             * @request POST:/v1/identity-verification
             * @secure
             */
            submitIdentityVerification: (data, params = {}) => this.request({
                path: `/v1/identity-verification`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Get the current user's identity verification status.
             *
             * @tags Identity Verification
             * @name GetIdentityVerificationStatus
             * @summary Get identity verification status
             * @request GET:/v1/identity-verification
             * @secure
             */
            getIdentityVerificationStatus: (params = {}) => this.request({
                path: `/v1/identity-verification`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Revoke the current user's identity verification.
             *
             * @tags Identity Verification
             * @name RevokeIdentityVerification
             * @summary Revoke identity verification
             * @request DELETE:/v1/identity-verification
             * @secure
             */
            revokeIdentityVerification: (params = {}) => this.request({
                path: `/v1/identity-verification`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Submit a new identity claim with proof from a supported provider. The proof is verified server-side via the provider adapter before storing.
             *
             * @tags Identity Claims
             * @name SubmitIdentityClaim
             * @summary Submit identity claim
             * @request POST:/v1/identity/claims
             * @secure
             */
            submitIdentityClaim: (data, params = {}) => this.request({
                path: `/v1/identity/claims`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description List the current user's verified identity claims. Raw proofs are stripped from the response.
             *
             * @tags Identity Claims
             * @name ListIdentityClaims
             * @summary List identity claims
             * @request GET:/v1/identity/claims
             * @secure
             */
            listIdentityClaims: (params = {}) => this.request({
                path: `/v1/identity/claims`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Toggle whether a verified identity claim is publicly disclosed. If connected to AT Protocol, syncs disclosure to PDS.
             *
             * @tags Identity Claims
             * @name UpdateIdentityClaim
             * @summary Update identity claim disclosure
             * @request PATCH:/v1/identity/claims/{claimId}
             * @secure
             */
            updateIdentityClaim: (claimId, data, params = {}) => this.request({
                path: `/v1/identity/claims/${claimId}`,
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Remove a verified identity claim. If the claim was disclosed and AT Protocol is connected, syncs the removal to PDS.
             *
             * @tags Identity Claims
             * @name DeleteIdentityClaim
             * @summary Delete identity claim
             * @request DELETE:/v1/identity/claims/{claimId}
             * @secure
             */
            deleteIdentityClaim: (claimId, params = {}) => this.request({
                path: `/v1/identity/claims/${claimId}`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get a user's publicly disclosed identity claims. No authentication required.
             *
             * @tags Identity Claims
             * @name GetPublicDisclosures
             * @summary Get public identity disclosures
             * @request GET:/v1/identity/disclosures/{username}
             * @secure
             */
            getPublicDisclosures: (username, params = {}) => this.request({
                path: `/v1/identity/disclosures/${username}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Generate a Reclaim Protocol proof request for the frontend to trigger the verification flow.
             *
             * @tags Identity Claims
             * @name CreateReclaimRequest
             * @summary Generate Reclaim proof request
             * @request POST:/v1/identity/reclaim/request
             * @secure
             */
            createReclaimRequest: (data, params = {}) => this.request({
                path: `/v1/identity/reclaim/request`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Initiate AT Protocol OAuth login (unauthenticated). Takes a Bluesky handle and returns an authorization URL.
             *
             * @tags AT Protocol
             * @name AtprotoLogin
             * @summary Initiate AT Protocol login
             * @request POST:/v1/atproto/login
             * @secure
             */
            atprotoLogin: (data, params = {}) => this.request({
                path: `/v1/atproto/login`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Handle the AT Protocol OAuth callback. The PDS redirects the user's browser here after authorization. Handles both login/register and account-linking modes. Returns a 302 redirect with auth cookies set.
             *
             * @tags AT Protocol
             * @name AtprotoCallback
             * @summary AT Protocol OAuth callback
             * @request GET:/v1/atproto/callback
             * @secure
             */
            atprotoCallback: (query, params = {}) => this.request({
                path: `/v1/atproto/callback`,
                method: "GET",
                query: query,
                secure: true,
                ...params,
            }),
            /**
             * @description Initiate AT Protocol OAuth account linking for an authenticated user. Returns an authorization URL.
             *
             * @tags AT Protocol
             * @name AtprotoConnect
             * @summary Link AT Protocol account
             * @request POST:/v1/atproto/connect
             * @secure
             */
            atprotoConnect: (data, params = {}) => this.request({
                path: `/v1/atproto/connect`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Disconnect the user's AT Protocol account. Revokes tokens at the PDS, deletes credential records, and removes the connection.
             *
             * @tags AT Protocol
             * @name AtprotoDisconnect
             * @summary Disconnect AT Protocol account
             * @request DELETE:/v1/atproto/connect
             * @secure
             */
            atprotoDisconnect: (params = {}) => this.request({
                path: `/v1/atproto/connect`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get the current user's AT Protocol connection status.
             *
             * @tags AT Protocol
             * @name AtprotoStatus
             * @summary Get AT Protocol connection status
             * @request GET:/v1/atproto/status
             * @secure
             */
            atprotoStatus: (params = {}) => this.request({
                path: `/v1/atproto/status`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Extend account TTL using a one-time magic link token. Recalculates expiresAt from today based on the user's tier TTL. Supports both POST body and query parameter.
             *
             * @tags Account Lifecycle
             * @name ExtendAccountTtl
             * @summary Extend account TTL
             * @request POST:/v1/account/extend
             * @secure
             */
            extendAccountTtl: (query, data, params = {}) => this.request({
                path: `/v1/account/extend`,
                method: "POST",
                query: query,
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Request account deletion. Verifies the user's password, then sends a confirmation email with a one-time magic link. The actual deletion happens when the user clicks the confirmation link.
             *
             * @tags Account Lifecycle
             * @name RequestAccountDeletion
             * @summary Request account deletion
             * @request POST:/v1/account
             * @secure
             */
            requestAccountDeletion: (data, params = {}) => this.request({
                path: `/v1/account`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Confirm account deletion using a one-time email token. Permanently deletes the user and all associated data. Supports both POST body and query parameter.
             *
             * @tags Account Lifecycle
             * @name ConfirmAccountDeletion
             * @summary Confirm account deletion
             * @request POST:/v1/account/confirm-deletion
             * @secure
             */
            confirmAccountDeletion: (query, data, params = {}) => this.request({
                path: `/v1/account/confirm-deletion`,
                method: "POST",
                query: query,
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Remove an account using email/phone and password credentials. Permanently deletes the user.
             *
             * @tags Account Lifecycle
             * @name RemoveAccount
             * @summary Remove account directly
             * @request DELETE:/v1/account/remove
             * @secure
             */
            removeAccount: (data, params = {}) => this.request({
                path: `/v1/account/remove`,
                method: "DELETE",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Request tier elevation to a permanent account. Consumes a one-time magic link token and flags the user for admin review. Supports both POST body and query parameter.
             *
             * @tags Account Lifecycle
             * @name RequestTierUpgrade
             * @summary Request tier upgrade
             * @request POST:/v1/account/request-upgrade
             * @secure
             */
            requestTierUpgrade: (query, data, params = {}) => this.request({
                path: `/v1/account/request-upgrade`,
                method: "POST",
                query: query,
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Promote the calling user to T6 super-admin. Only works when zero admin users exist in the database. Permanently locked after the first admin is created.
             *
             * @tags Admin
             * @name AdminBootstrap
             * @summary Bootstrap first super-admin
             * @request POST:/v1/admin/bootstrap
             * @secure
             */
            adminBootstrap: (params = {}) => this.request({
                path: `/v1/admin/bootstrap`,
                method: "POST",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description List all users in the system. Admin access required.
             *
             * @tags Admin
             * @name AdminListUsers
             * @summary List all users
             * @request GET:/v1/admin/users
             * @secure
             */
            adminListUsers: (params = {}) => this.request({
                path: `/v1/admin/users`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get detailed information about a specific user. Admin access required.
             *
             * @tags Admin
             * @name AdminGetUser
             * @summary Get user detail
             * @request GET:/v1/admin/users/{userId}
             * @secure
             */
            adminGetUser: (userId, params = {}) => this.request({
                path: `/v1/admin/users/${userId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Update user properties (tier, role, scopes, status, plan). Admin access required. Cannot self-demote.
             *
             * @tags Admin
             * @name AdminUpdateUser
             * @summary Update user
             * @request PUT:/v1/admin/users/{userId}
             * @secure
             */
            adminUpdateUser: (userId, data, params = {}) => this.request({
                path: `/v1/admin/users/${userId}`,
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Disable MFA for a specific user. Admin access required.
             *
             * @tags Admin
             * @name AdminDisableMfa
             * @summary Disable user MFA
             * @request DELETE:/v1/admin/users/{userId}/mfa
             * @secure
             */
            adminDisableMfa: (userId, params = {}) => this.request({
                path: `/v1/admin/users/${userId}/mfa`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description List all plans with user counts. Admin access required.
             *
             * @tags Admin
             * @name AdminListPlans
             * @summary List plans
             * @request GET:/v1/admin/plans
             * @secure
             */
            adminListPlans: (params = {}) => this.request({
                path: `/v1/admin/plans`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Create a new plan. Admin access required.
             *
             * @tags Admin
             * @name AdminCreatePlan
             * @summary Create plan
             * @request POST:/v1/admin/plans
             * @secure
             */
            adminCreatePlan: (data, params = {}) => this.request({
                path: `/v1/admin/plans`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Get detailed plan info with user count. Admin access required.
             *
             * @tags Admin
             * @name AdminGetPlan
             * @summary Get plan detail
             * @request GET:/v1/admin/plans/{planId}
             * @secure
             */
            adminGetPlan: (planId, params = {}) => this.request({
                path: `/v1/admin/plans/${planId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Update an existing plan. Admin access required.
             *
             * @tags Admin
             * @name AdminUpdatePlan
             * @summary Update plan
             * @request PUT:/v1/admin/plans/{planId}
             * @secure
             */
            adminUpdatePlan: (planId, data, params = {}) => this.request({
                path: `/v1/admin/plans/${planId}`,
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Delete a plan. Admin access required.
             *
             * @tags Admin
             * @name AdminDeletePlan
             * @summary Delete plan
             * @request DELETE:/v1/admin/plans/{planId}
             * @secure
             */
            adminDeletePlan: (planId, params = {}) => this.request({
                path: `/v1/admin/plans/${planId}`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Seed plans from TIER_DEFAULTS and assign planIds to existing users. Idempotent - skips if plans already exist. Admin access required.
             *
             * @tags Admin
             * @name AdminSeedPlans
             * @summary Seed default plans
             * @request POST:/v1/admin/seed-plans
             * @secure
             */
            adminSeedPlans: (params = {}) => this.request({
                path: `/v1/admin/seed-plans`,
                method: "POST",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Archive all users with expiresAt < now and status = active. Can be triggered by cron or manually.
             *
             * @tags Admin
             * @name AdminArchiveExpired
             * @summary Archive expired accounts
             * @request POST:/v1/admin/archive-expired
             * @secure
             */
            adminArchiveExpired: (params = {}) => this.request({
                path: `/v1/admin/archive-expired`,
                method: "POST",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Send expiration warning emails to users whose accounts expire within 7 days. Idempotent - tracks sent warnings to avoid duplicates within 5 days.
             *
             * @tags Admin
             * @name AdminSendExpirationWarnings
             * @summary Send expiration warning emails
             * @request POST:/v1/admin/send-expiration-warnings
             * @secure
             */
            adminSendExpirationWarnings: (params = {}) => this.request({
                path: `/v1/admin/send-expiration-warnings`,
                method: "POST",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get list of OAuth accounts linked to the authenticated user.
             *
             * @tags OAuth
             * @name ListOAuthAccounts
             * @summary List linked OAuth accounts
             * @request GET:/v1/user/oauth-accounts
             * @secure
             */
            listOAuthAccounts: (params = {}) => this.request({
                path: `/v1/user/oauth-accounts`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Unlink an OAuth provider from the authenticated user's account. Cannot unlink if it is the only authentication method.
             *
             * @tags OAuth
             * @name UnlinkOAuthProvider
             * @summary Unlink OAuth provider
             * @request DELETE:/v1/oauth/{provider}/unlink
             * @secure
             */
            unlinkOAuthProvider: (provider, params = {}) => this.request({
                path: `/v1/oauth/${provider}/unlink`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Returns which sign-in methods the server can currently service, derived from environment configuration. The auth frontend embeds this at build time to hide unconfigured methods. Public, no auth.
             *
             * @tags Authentication
             * @name GetEnabledMethods
             * @summary Get enabled auth methods
             * @request GET:/v1/auth/enabled-methods
             * @secure
             */
            getEnabledMethods: (params = {}) => this.request({
                path: `/v1/auth/enabled-methods`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description For a returning user (recognised by a device fingerprint that has logged in here before), returns their configured sign-in methods plus a recommended / most-used hint and, if their profile is public, avatar details. Gated behind the device soft-signal; uniform for unknown devices/emails. Rate-limited per IP.
             *
             * @tags Authentication
             * @name GetLoginOptions
             * @summary Get a returning user's login options
             * @request POST:/v1/auth/login-options
             * @secure
             */
            getLoginOptions: (data, params = {}) => this.request({
                path: `/v1/auth/login-options`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Invite someone to an app by email. Requires the inviter's access token. The emailed link is a magic link that signs the recipient in (creating an account from their email if needed) and redirects into the inviting app.
             *
             * @tags Authentication
             * @name SendAppInvite
             * @summary Send an app invite
             * @request POST:/v1/invite
             * @secure
             */
            sendAppInvite: (data, params = {}) => this.request({
                path: `/v1/invite`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Navigate the browser here — do not fetch it. Sets an HttpOnly `oauth_flow` cookie (state, PKCE verifier, destination) and redirects to the provider. Failures redirect to the auth FE page for the flow, with `oauth_error` and `oauth_message` query params.
             *
             * @tags OAuth
             * @name OauthStart
             * @summary Start OAuth sign-in (browser navigation)
             * @request GET:/v1/oauth/{provider}/start
             * @secure
             */
            oauthStart: (provider, query, params = {}) => this.request({
                path: `/v1/oauth/${provider}/start`,
                method: "GET",
                query: query,
                secure: true,
                ...params,
            }),
        };
        this.oauth = {
            /**
             * @description Serve the AT Protocol OAuth client metadata. Publicly accessible; the PDS fetches this during Pushed Authorization Request.
             *
             * @tags AT Protocol
             * @name AtprotoClientMetadata
             * @summary AT Protocol OAuth client metadata
             * @request GET:/oauth/client-metadata.json
             * @secure
             */
            atprotoClientMetadata: (params = {}) => this.request({
                path: `/oauth/client-metadata.json`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Serve the AT Protocol OAuth JWKS (public keys). Authorization servers use this to verify client assertions.
             *
             * @tags AT Protocol
             * @name AtprotoJwks
             * @summary AT Protocol OAuth JWKS
             * @request GET:/oauth/jwks.json
             * @secure
             */
            atprotoJwks: (params = {}) => this.request({
                path: `/oauth/jwks.json`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.wellKnown = {
            /**
             * @description Serve the RS256 public key in JWKS format for JWT verification.
             *
             * @tags Token Management
             * @name GetJwks
             * @summary JSON Web Key Set
             * @request GET:/.well-known/jwks.json
             * @secure
             */
            getJwks: (params = {}) => this.request({
                path: `/.well-known/jwks.json`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
    }
}
